import Repository from './Repository';

export default {
    getLinksManagerData () {
        return Repository.get('author/links_manager');
    }
}